import React from "react";

const ArrowRightIcon = ({ color = "#ffffff", width = "14", height = "12" }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 26 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <line y1="9" x2="24" y2="9" stroke={color} strokeWidth="2" />
      <line
        x1="16.7071"
        y1="1.29289"
        x2="25.1924"
        y2="9.77817"
        stroke={color}
        strokeWidth="2"
      />
      <line
        x1="16.3329"
        y1="17.2129"
        x2="24.8182"
        y2="8.72763"
        stroke={color}
        strokeWidth="2"
      />
    </svg>
  );
};

export default ArrowRightIcon;
